import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useCallback } from "react";

import type { FC } from "react";

export type AiImageStyle = "illustration" | "realistic" | "3d" | "line-art";
export const AiImageStyleConfig = {
  illustration: {
    name: "Illustration",
    referenceImageSrc:
      "https://images.changeengine.com/18f1adb9-a12b-4e58-ab41-13d7b296bd40/accdcd6b-f036-4a77-9120-f0ceb8957951",
  },
  realistic: {
    name: "Realistic",
    referenceImageSrc:
      "https://images.changeengine.com/18f1adb9-a12b-4e58-ab41-13d7b296bd40/269e6ab8-f53d-4102-b10c-eee90482104b",
  },
  "3d": {
    name: "3D",
    referenceImageSrc:
      "https://images.changeengine.com/18f1adb9-a12b-4e58-ab41-13d7b296bd40/63e070a2-15c6-4e57-bef9-918f84bc0ae3",
  },
  "line-art": {
    name: "Line art",
    referenceImageSrc:
      "https://images.changeengine.com/18f1adb9-a12b-4e58-ab41-13d7b296bd40/3555f38e-07fd-4047-808d-c2c17e46d130",
  },
};

export const AiImageStyleToggle: FC<{
  aiImageStyle?: string;
  onChange: (style: string) => void;
}> = ({ aiImageStyle, onChange }) => {
  const handleChange = useCallback(
    (_: React.MouseEvent<HTMLElement>, newStyle: string) => {
      onChange(newStyle);
    },
    [onChange],
  );

  return (
    <ToggleButtonGroup
      color="primary"
      value={aiImageStyle}
      exclusive
      onChange={handleChange}
      aria-label="Default AI image style"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        columnGap: 0.5,
        rowGap: 0.5,
        "& .MuiToggleButtonGroup-grouped": {
          padding: 0.5,
          border: "1px solid transparent",
          "&:not(:first-of-type)": { borderRadius: 1 },
          "&:first-of-type": { borderRadius: 1 },
        },
      }}
    >
      <AiImageStyleToggleButton
        analyticsId="default-ai-image-style-illustration"
        imageStyle="illustration"
      />
      <AiImageStyleToggleButton
        analyticsId="default-ai-image-style-realistic"
        imageStyle="realistic"
      />
      <AiImageStyleToggleButton analyticsId="default-ai-image-style-3d" imageStyle="3d" />
      <AiImageStyleToggleButton
        analyticsId="default-ai-image-style-line-art"
        imageStyle="line-art"
      />
    </ToggleButtonGroup>
  );
};

const AiImageStyleToggleButton: FC<{
  analyticsId: string;
  imageStyle: AiImageStyle;
}> = ({ analyticsId, imageStyle }) => (
  <ToggleButton data-analytics-id={analyticsId} value={imageStyle} sx={{ textTransform: "none" }}>
    <Stack alignItems="center">
      <img
        src={AiImageStyleConfig[imageStyle].referenceImageSrc}
        width="76px"
        height="76px"
        alt={AiImageStyleConfig[imageStyle].name}
        style={{ objectFit: "contain", borderRadius: "12px" }}
      />
      <Typography variant="body2">{AiImageStyleConfig[imageStyle].name}</Typography>
    </Stack>
  </ToggleButton>
);
